import { useRef, useState } from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { Trans } from '@lingui/react/macro'

import { useBrandName } from '@jotta/grpc-connect-client/config'
import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@jotta/ui/Dialog'
import SvgLogo_iconLight from '@jotta/ui/SvgLogo_iconLight'
import SvgX from '@jotta/ui/SvgX'

export function AppPromotionDrawer({
  open,
  onLinkClick,
  onClose,
  downloadMobileAppLink,
}: {
  open: boolean
  onLinkClick: () => void
  onClose: () => void
  downloadMobileAppLink: string
}) {
  const brandName = useBrandName()
  const [closing, setClosing] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  return (
    <Dialog
      modal
      open={open}
      onOpenChange={open => {
        if (!open) {
          setClosing(true)
        }
      }}
    >
      <AnimatePresence
        onExitComplete={() => {
          onClose()
          setClosing(false)
        }}
      >
        {!closing && (
          <DialogContent
            asChild
            className="fixed -bottom-[300px] left-0 top-auto z-[51] flex max-h-none w-full max-w-none translate-x-0 translate-y-0 flex-col gap-8 rounded-b-none rounded-t-xl border bg-primary p-8 pb-[332px] shadow-none outline-none backdrop-blur-none data-[state=closed]:!animate-none data-[state=open]:!animate-none sm:max-w-none"
          >
            <motion.div
              ref={ref}
              drag="y"
              dragElastic={{
                top: 0,
                bottom: 1,
              }}
              dragConstraints={{ top: 0, bottom: 0 }}
              onDragEnd={(_, info) => {
                const clientHeight = ref.current?.clientHeight
                if (clientHeight && info.offset.y > (clientHeight - 300) / 2) {
                  setClosing(true)
                }
              }}
              transition={{
                type: 'tween',
              }}
              initial={{ translateY: '100%' }}
              exit={{ translateY: '100%' }}
              animate={{ translateY: '0%' }}
            >
              <button
                className="btn btn-elevated absolute right-2 top-2 p-4"
                onClick={() => setClosing(true)}
              >
                <PlainBrandIcon icon={SvgX} height={24} />
              </button>
              <PlainBrandIcon
                className="self-center"
                icon={SvgLogo_iconLight}
                height={50}
              />
              <div className="text-center">
                <DialogTitle className="sr-only">
                  <Trans>Get the full app experience</Trans>
                </DialogTitle>
                <header className="h2" aria-hidden="true">
                  <Trans>Get the full app experience</Trans>
                </header>
                <DialogDescription asChild>
                  <p>
                    <Trans>
                      Use the mobile app to make the most out of {brandName}
                    </Trans>
                  </p>
                </DialogDescription>
              </div>
              <a
                className="btn btn-primary"
                href={downloadMobileAppLink}
                onClick={() => onLinkClick()}
                rel="noreferrer"
              >
                <Trans>Download app</Trans>
              </a>
            </motion.div>
          </DialogContent>
        )}
      </AnimatePresence>
    </Dialog>
  )
}
